import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AccountSelectionService } from './account-selection.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AccountSelectionInterceptor } from './account-selection.interceptor';
import { accountSelectionOccConfig } from '../../../../../../../core/occ/occ-account-selection-config';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (accountSelectionService: AccountSelectionService) => () => accountSelectionService.init(),
      deps: [AccountSelectionService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccountSelectionInterceptor,
      multi: true,
    },
    provideConfig(accountSelectionOccConfig),
  ],
})
export class AccountSelectionModule {}
